import { Route, Routes } from 'react-router-dom';
import { DiscountAtCheckoutProductsPage } from './DiscountAtCheckoutProductsPage';
import { DiscountAtCheckoutSettingsPage } from './DiscountAtCheckoutSettingsPage';

export const DiscountAtCheckoutPageRoot = () => (
  <Routes>
    <Route path='/settings' element={<DiscountAtCheckoutSettingsPage />} />
    <Route path='*' element={<DiscountAtCheckoutProductsPage />} />
  </Routes>
);
